import React from 'react'

import { Close, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

const ICON_SIZE = { width: '16px', height: '16px' }

function CgdreamNoticeBar({ locale = 'en', onDismiss }) {
  const translate = key => i18n.t(`cgdream_notice_bar.${key}`, { ns: 'rails', lng: locale })

  return (
    <div className="cgdream-notice-bar timer-strip--top-bar" role="status">
      <div className="timer-strip timer-strip--subscription">
        <div className="timer-row">
          <p className="cgdream-notice-bar__message">{translate('message')}</p>
        </div>
      </div>
      <button
        type="button"
        className="cgdream-notice-bar__dismiss"
        aria-label={translate('dismiss')}
        onClick={onDismiss}
      >
        <Icon svgComponent={Close} color="dark" notSpaced size={ICON_SIZE} />
      </button>
    </div>
  )
}

CgdreamNoticeBar.propTypes = {
  locale: string,
  onDismiss: func.isRequired,
}

export default CgdreamNoticeBar
